
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSubscriptionDetails } from "../../../apis/subscriptionsApis";
 
const SubscriptionDetails = () => {
  const { id } = useParams();
  const [subDetails, setSubDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [subscribers,setSubscribers] = useState([])
  const [info, setInfo] = useState({})
  const navigate = useNavigate();
 
  useEffect(() => {
    if (id) subscriptionDetails(id);
  }, [id]);
 
  const subscriptionDetails = async () => {
    try {
      const res = await getSubscriptionDetails(id);
      if (res.success) {
        setSubDetails(res.result);
        // setSubscribers(res.result.subScribers[0])
        setInfo(res.result.subInfo)
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
 
  const backClick = () => {
    navigate("/subscriptions");
  };
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-GB").replace(/\//g, "-");
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
     
    }).toLowerCase();
    return `${formattedDate}  ${formattedTime}`;
  };
 
  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: 250, paddingTop: 75 }}
    >
      <i
        className="fas fa-arrow-left"
        style={{ marginRight: "30px", fontSize: "20px" }}
        onClick={backClick}
      />
      {loading ? (
        <div>Loading...</div>
      ) : (
        <>
          {subDetails && (
            <div className="table-responsive">
              <table
                className="table table-striped table-hover "
                style={{ marginTop: 25 }}
              >
                <tbody>
                  <tr>
                    <td>
                      <strong> Name of Subscriber: </strong>
                    </td>
                    <td>{subDetails.nameOfSubscriber}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong> Seq Number: </strong>
                    </td>
                    <td>{subDetails.seqNo}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong> Financial Advisor Name: </strong>
                    </td>
                    <td>{subDetails.introducerName}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong> Financial Advisor Firm: </strong>
                    </td>
                    <td>{subDetails.investmentId}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong> Investment Amount: </strong>
                    </td>
                    <td>{subDetails.investmentAmount}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong> ShareClass Type: </strong>
                    </td>
                    <td>{subDetails.shareClassType}</td>
                  </tr>
                  
                  <tr>
                    <td>
                      <strong> Funds Received Origin: </strong>
                    </td>
                    <td>{subDetails.fundsReceivedOrigin}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong> Existing Inv: </strong>
                    </td>
                    <td>{subDetails.existingInv}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong> Account Holder Name: </strong>
                    </td>
                    <td>{subDetails.accountHolderName}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Confirm Bank Details: </strong>
                    </td>
                    <td>{subDetails.confirmBankDetails}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>IBAN: </strong>
                    </td>
                    <td>{subDetails.iban}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
 
          <div>
            {loading ? (
              <div>Loading...</div>
            ) : subDetails &&
              subDetails.subSubscribers &&
              subDetails.subSubscribers.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> # </th>
                      <th> Name </th>
                      <th> Email </th>
                      <th> Address1 </th>
                      <th> Address2 </th>
                      <th> Address3 </th>
                      <th> Date of Birth </th>
                      <th> Mobile </th>
                      <th> Country </th>
                      <th> Nationality </th>
                      <th> Occupation </th>
                      <th> Post Code </th>
                      <th> Spouse Name </th>
                      <th> Spouse Email </th>
                      <th> Ireland Subscriber </th>
                      <th> CRS TaxNo </th>
                      <th> SOF Part2 Salary </th>
                      <th> SOF Part2 Type </th>
                      <th> SOF Part3 </th>
                      <th> SOW Part1 </th>
                      <th> SOW Part2 </th>
                      <th> PEP </th>
                      {/* <th> Created At </th> */}

                    </tr>
                  </thead>
                  <tbody>
                    {info && subDetails.subSubscribers && subDetails.subSubscribers.map((sub, index) => (
                      <tr key={index}>
                        <td> {index + 1} </td>
                        <td> {` ${sub.subscribers.title} ${sub.subscribers.firstName} ${sub.subscribers.lastName}`} </td>
                        <td> {sub.subscribers.email} </td>
                        <td> {sub.subscribers.address1} </td>
                        <td> {sub.subscribers.address2} </td>
                        <td> {sub.subscribers.address3} </td>
                        <td> {sub.subscribers.dateOfBirth} </td>
                        <td> {sub.subscribers.mobileCountryCode} {sub.subscribers.mobileCountryCalling} {sub.subscribers.mobile} </td>
                        <td> {sub.subscribers.country} </td>    
                        <td> {sub.subscribers.nationality} </td>
                        <td> {sub.subscribers.occupation} </td>
                        <td> {sub.subscribers.postCode} </td>
                        <td> {sub.subscribers.spouseName} </td>
                        <td> {sub.subscribers.spouseEmail} </td>
                        <td> {info.irelandSubscriber} </td>
                        <td> {info.crsTaxNo} </td>
                        <td> {info.sofPart2Salary} </td>
                        <td> {info.sofPart2Type} </td>
                        <td> {info.sofPart3} </td>
                        <td> {info.sowPart1} </td>
                        <td> {info.sowPart2} </td>
                        <td> {info.pep} </td>
                        {/* <td> {formatDateTime(sub.createdAt)} </td> */}

                       
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div>No Records found</div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
 
export default SubscriptionDetails;